import React, { SVGProps } from "react"

export default function BaseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon"
      width="1em"
      height="1em"
      viewBox="0 0 44 44"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.8929 16.7071L26.8929 16.707L26.8923 16.708C26.476 17.4236 25.8814 17.9603 25.1674 18.3183L25.1198 18.3422L25.165 18.3702C26.1823 19.0002 26.8816 19.568 27.3272 20.2681C27.7724 20.9675 27.9666 21.8022 27.9666 22.9703C27.9666 24.8249 27.3256 26.1672 26.2032 27.0466C25.0797 27.927 23.4697 28.3468 21.5264 28.3468H16.1645V9.66453H21.3467C23.3204 9.66453 24.8706 10.0545 25.9267 10.845C26.9813 11.6344 27.5472 12.8262 27.5472 14.4404C27.5472 15.2756 27.3092 16.051 26.8929 16.7071ZM19.7891 12.5484H19.7593V12.5782V17.0834V17.1132H19.7891H21.107C22.7954 17.1132 23.8925 16.1437 23.8925 14.8608C23.8925 14.164 23.6808 13.5846 23.2465 13.1796C22.8125 12.775 22.1603 12.5484 21.2868 12.5484H19.7891ZM19.7593 25.4331V25.4629H19.7891H21.3467C22.3107 25.4629 23.0527 25.1909 23.5613 24.7038C24.0699 24.2166 24.3416 23.5177 24.3717 22.671L24.3718 22.671V22.6699C24.3718 21.7906 24.0387 21.1208 23.4617 20.6716C22.8857 20.2233 22.0697 19.9971 21.107 19.9971H19.7891H19.7593V20.0268V25.4331ZM16.1645 30.9893H26.409V34.2937H16.1645V30.9893Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.0595238"
      ></path>
      <circle cx="22" cy="22" r="21.25" stroke="currentColor" strokeWidth="1.5"></circle>
    </svg>
  )
}
